import { Component } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { ModalFooterComponent } from '../modal-footer/modal-footer.component';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe } from '@angular/common';
import { ButtonType } from '@core/models';
import { DialogRef } from '@angular/cdk/dialog';
import { SvgComponent } from '../svg/svg.component';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'sc-confirmation-modal',
  imports: [
    ModalComponent,
    SvgComponent,
    ButtonComponent,
    ModalFooterComponent,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './confirmation-modal.component.html',
})
export class ConfirmationModalComponent {
  public ButtonType = ButtonType;

  constructor(private readonly dialogRef: DialogRef<boolean>) {}

  public close(approved: boolean = false) {
    this.dialogRef.close(approved);
  }
}
